import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { configureStore, history } from 'store/store'
import 'placeholder-loading/src/scss/placeholder-loading.scss'
import 'assets/scss/styles.scss'
import { getUserToken } from 'utils/storageUtils'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import ConnectDefaultLayout from './DefaultLayout'
import { ConnectedRouter } from 'connected-react-router'

if (window.location.pathname === '/login' || window.location.pathname === '/register') {
  const token = getUserToken()
  if (token) {
    window.location.href = process.env.REACT_APP_BASE_URL
  }
}

// Init Amplitude
if (window.amplitude) {
  window.amplitude.getInstance().init(process.env.REACT_APP_AMPLITUDE_API_KEY, null, { domain: process.env.REACT_APP_BASE_URL, language: 'en-US' })
}

window.CopyResponseSound = new Audio('https://klutch.nyc3.digitaloceanspaces.com/copy-response.mp3')

const root = createRoot(document.getElementById('root'))
const _store = configureStore()
root.render(
  <Provider store={_store}>
    <ConnectedRouter history={history}>
      <ConnectDefaultLayout />
    </ConnectedRouter>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register()

// Hide Add to home screen popup:
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  window.deferredPrompt = e
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
